import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Button,
  Modal,
  Header,
  Menu,
  Image,
} from "semantic-ui-react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteDatasets } from "../../actions/dataConsoleAction";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/Loader";
import "../../styles/MobileApprovedDataset.css";

const MobileApprovedDataset = ({
  data,
  showToaster,
  setDeleteStatus,
  loaderFlag,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);
  const { loadings, responseDelete, errors } = useSelector(
    (state) => state.getdeleteDataSetReducer || {}
  );
  const { response } = useSelector(
    (state) => state.getlistDatasetReducer || {}
  );
  const [openDeleteBox, setopenDeleteBox] = useState(false);
  const [deleteFlag, setdeleteFlag] = useState(false);
  const [deleteDatsetName, setdeleteDatsetName] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (responseDelete.status_code === 200 && deleteFlag) {
      showToaster(`${deleteDatsetName} deleted successfully`, "success");
      setDeleteStatus(true);
      setdeleteFlag(false);
    }
    if (responseDelete.status === "failed") {
      setDeleteStatus(true);
      showToaster(responseDelete.message, "error");
    }
  }, [response, responseDelete, dispatch]);

  const totalItems = data.length;

  const DocumentCard = ({ document, files, isReferenceDataset }) => {
    return (
      <Card fluid>
        <Card.Content>
          <Card.Header>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span>{document}</span>
              {isReferenceDataset && (
                <span
                  title="Reference dataset for QuickChat configurations"
                  style={{
                    backgroundColor: '#ebf8f2',
                    border: '1px solid #28a745',
                    borderRadius: '24px',
                    color: '#28a745',
                    padding: '4px 12px',
                    fontSize: '12px', // Slightly smaller font size
                    fontWeight: 'normal',
                    textTransform: 'none',
                    letterSpacing: 'normal',
                    display: 'inline-block'
                  }}
                >
                  Reference Dataset
                </span>
              )}
            </div>
          </Card.Header>
          <Card.Meta>
            <div>
              <div className="mobile-dataset-document-card">
                <p> Documents: </p>
                <p>{files}</p>
              </div>
            </div>
          </Card.Meta>
        </Card.Content>
      </Card>
    );
  };

  return (
    <>
      <Container>
        {data.length > 0
          ? data.map((row) => (
              <DocumentCard
                document={row.datasetName}
                files={
                  row.files.length > 0
                    ? row.files.length < 9
                      ? row.files[0] +
                        (row.files.length < 2
                          ? ""
                          : "  +" + (row.files.length - 1) + " more  ")
                      : row.files[0].slice(0, 9) +
                        "..." +
                        (row.files.length < 2
                          ? ""
                          : "  +" + (row.files.length - 1) + " more  ")
                    : "-"
                }
                isReferenceDataset={row.isReferenceDataset}
              />
            ))
          : ""}
      </Container>
    </>
  );
};

export default MobileApprovedDataset;
